import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router';
import queryString from 'query-string';
import pick from 'lodash.pick';
import isEmpty from 'lodash.isempty';
import areOptionsEqual from '@utils/areOptionsEqual';
import {getValidPackagesParams} from '@utils/getValidPackagesParams';
import {
    DEFAULT_TEMPLATES_OPTIONS, TEMPLATES_PATH
} from '../../constants';
import {
    fetchTemplates, selectOptions, selectTemplates, selectTemplatesPerPage, setOptions
} from '../components/Templates/templatesSlice';
import {selectUserAttributes} from '../components/Login/userSlice';

export default function useTemplatesPageNavigate(onSuccess, navigateImmediately) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const options = useSelector(selectOptions);
    const templates = useSelector(selectTemplates);
    const templatesPerPage = useSelector(selectTemplatesPerPage);
    const userAttributes = useSelector(selectUserAttributes);

    return async (pageOptions = {}, shouldResetPages) => {
        const newOptions = {
            ...DEFAULT_TEMPLATES_OPTIONS,
            ...options,
            ...getValidPackagesParams(pageOptions, userAttributes)
        };
        if (shouldResetPages) {
            newOptions.from = DEFAULT_TEMPLATES_OPTIONS.from;
            newOptions.to = templatesPerPage;
        }

        const filteredNewOptions = pick(newOptions, [
            'from',
            'to',
            'sort',
            'dir',
            'search',
            'visibility'
        ]);
        const newQuery = queryString.stringify(filteredNewOptions);

        const previousOptions = pick(options, Object.keys(filteredNewOptions));
        const isSilent = !isEmpty(templates)
            && areOptionsEqual(filteredNewOptions, previousOptions);

        dispatch(setOptions(filteredNewOptions));

        if (navigateImmediately) {
            navigate(`${TEMPLATES_PATH}?${newQuery}`);
        }

        const wasSuccessful = await dispatch(fetchTemplates({isSilent}));
        if (wasSuccessful) {
            if (onSuccess) {
                onSuccess();
            }
            if (!navigateImmediately) {
                navigate(`${TEMPLATES_PATH}?${newQuery}`);
            }
        }
    };
}
